import api from 'services/api';

import { IDataFilterProps, SelectItem } from '../types';

export const handleDataFilter = (
  dataFilter: IDataFilterProps,
  isAzureFunction: boolean
) => {
  const azureFunctionsCode = process.env.REACT_APP_PROD_AZUREFUNCTIONS_CODE;
  const azureFunctiouRoute = isAzureFunction
    ? `https://functions.pdahub.com.br/api/`
    : `${process.env.REACT_APP_PROD_AZUREFUNCTIONS_URL}`;

  return api.patch(
    `${azureFunctiouRoute}Picking/Estornar?code=${azureFunctionsCode}`,
    { ...dataFilter }
  );
};

export const handleParamiters = async (idCliente: Number) => {
  const [statusList, stutusEdit, brandList] = await Promise.all([
    api.get<SelectItem[]>(
      `Common/StatusPicking?codigoCliente=${Number(idCliente)}`
    ),
    api.get<SelectItem>(
      `Common/StatusPicking/Estornar?codigoCliente=${Number(idCliente)}`
    ),
    api.get(`Common/Marca?CodigoCliente=${Number(idCliente)}`),
  ]);

  return {
    statusList,
    stutusEdit,
    brandList,
  };
};

export const handleEdit = (
  idCliente: Number,
  codigoDelete: String,
  code: string,
  isAzureFunction: boolean
) => {
  const azureFunctionsCode = process.env.REACT_APP_PROD_AZUREFUNCTIONS_CODE;
  const azureFunctiouRoute = isAzureFunction
    ? `https://functions.pdahub.com.br/api/`
    : process.env.REACT_APP_PROD_AZUREFUNCTIONS_URL;
  return api.delete(
    `${azureFunctiouRoute}Picking/Estornar?code=${azureFunctionsCode}&codigoCliente=${Number(
      idCliente
    )}&codigoPedido=${String(codigoDelete)}&codeStatus=${code}`
  );
};
